import { twMerge } from "tailwind-merge";

import { AccessibleIcon } from "./accessible-icon";

export function EyeIcon({
  "aria-label": arialLabel,
  ...props
}: JSX.IntrinsicElements["svg"]) {
  return (
    <AccessibleIcon aria-label={arialLabel}>
      <svg
        fill="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
        <path
          clipRule="evenodd"
          d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 0 1 0-1.113ZM17.25 12a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z"
          fillRule="evenodd"
        />
      </svg>
    </AccessibleIcon>
  );
}

export function EyeOffIcon({
  "aria-label": arialLabel,
  ...props
}: JSX.IntrinsicElements["svg"]) {
  return (
    <AccessibleIcon aria-label={arialLabel}>
      <svg
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          clipRule="evenodd"
          d="M3.28 2.22a.75.75 0 0 0-1.06 1.06l14.5 14.5a.75.75 0 1 0 1.06-1.06l-1.745-1.745a10.029 10.029 0 0 0 3.3-4.38 1.651 1.651 0 0 0 0-1.185A10.004 10.004 0 0 0 9.999 3a9.956 9.956 0 0 0-4.744 1.194L3.28 2.22ZM7.752 6.69l1.092 1.092a2.5 2.5 0 0 1 3.374 3.373l1.091 1.092a4 4 0 0 0-5.557-5.557Z"
          fillRule="evenodd"
        />
        <path d="m10.748 13.93 2.523 2.523a9.987 9.987 0 0 1-3.27.547c-4.258 0-7.894-2.66-9.337-6.41a1.651 1.651 0 0 1 0-1.186A10.007 10.007 0 0 1 2.839 6.02L6.07 9.252a4 4 0 0 0 4.678 4.678Z" />
      </svg>
    </AccessibleIcon>
  );
}

export function CheckIcon({
  "aria-label": arialLabel,
  ...props
}: JSX.IntrinsicElements["svg"]) {
  return (
    <AccessibleIcon aria-label={arialLabel}>
      <svg
        fill="currentColor"
        strokeWidth="2"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          clipRule="evenodd"
          d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
          fillRule="evenodd"
        />
      </svg>
    </AccessibleIcon>
  );
}

export function PlusIcon({
  "aria-label": arialLabel,
  ...props
}: JSX.IntrinsicElements["svg"]) {
  return (
    <AccessibleIcon aria-label={arialLabel}>
      <svg
        fill="none"
        height="24"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path d="M5 12h14" />
        <path d="M12 5v14" />
      </svg>
    </AccessibleIcon>
  );
}

export function MinusIcon({
  "aria-label": arialLabel,
  ...props
}: JSX.IntrinsicElements["svg"]) {
  return (
    <AccessibleIcon aria-label={arialLabel}>
      <svg
        fill="none"
        height="24"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path d="M5 12h14" />
      </svg>
    </AccessibleIcon>
  );
}

export function XIcon({
  "aria-label": arialLabel,
  ...props
}: JSX.IntrinsicElements["svg"]) {
  return (
    <AccessibleIcon aria-label={arialLabel}>
      <svg
        fill="none"
        height="24"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path d="M18 6 6 18" />
        <path d="m6 6 12 12" />
      </svg>
    </AccessibleIcon>
  );
}

export function CalendarIcon({
  "aria-label": arialLabel,
  ...props
}: JSX.IntrinsicElements["svg"]) {
  return (
    <AccessibleIcon aria-label={arialLabel}>
      <svg
        height="1em"
        viewBox="0 0 56 56"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M11.992 49.574h32.016c4.899 0 7.36-2.437 7.36-7.265V13.69c0-4.828-2.461-7.265-7.36-7.265H11.992c-4.875 0-7.36 2.414-7.36 7.265v28.62c0 4.851 2.485 7.265 7.36 7.265m-.328-3.773c-2.086 0-3.258-1.102-3.258-3.282V20.419c0-2.156 1.172-3.281 3.258-3.281h32.649c2.085 0 3.28 1.125 3.28 3.281V42.52c0 2.18-1.195 3.28-3.28 3.28Zm11.742-20.25h1.383c.82 0 1.102-.235 1.102-1.055v-1.383c0-.82-.281-1.078-1.102-1.078h-1.383c-.82 0-1.078.258-1.078 1.078v1.383c0 .82.258 1.055 1.078 1.055m7.805 0h1.36c.843 0 1.101-.235 1.101-1.055v-1.383c0-.82-.258-1.078-1.102-1.078h-1.359c-.82 0-1.101.258-1.101 1.078v1.383c0 .82.28 1.055 1.101 1.055m7.781 0h1.383c.82 0 1.102-.235 1.102-1.055v-1.383c0-.82-.282-1.078-1.102-1.078h-1.383c-.82 0-1.101.258-1.101 1.078v1.383c0 .82.281 1.055 1.101 1.055m-23.367 7.664h1.383c.82 0 1.102-.235 1.102-1.055v-1.383c0-.82-.282-1.054-1.102-1.054h-1.383c-.82 0-1.101.234-1.101 1.054v1.383c0 .82.28 1.055 1.101 1.055m7.781 0h1.383c.82 0 1.102-.235 1.102-1.055v-1.383c0-.82-.281-1.054-1.102-1.054h-1.383c-.82 0-1.078.234-1.078 1.054v1.383c0 .82.258 1.055 1.078 1.055m7.805 0h1.36c.843 0 1.101-.235 1.101-1.055v-1.383c0-.82-.258-1.054-1.102-1.054h-1.359c-.82 0-1.101.234-1.101 1.054v1.383c0 .82.28 1.055 1.101 1.055m7.781 0h1.383c.82 0 1.102-.235 1.102-1.055v-1.383c0-.82-.282-1.054-1.102-1.054h-1.383c-.82 0-1.101.234-1.101 1.054v1.383c0 .82.281 1.055 1.101 1.055m-23.367 7.687h1.383c.82 0 1.102-.258 1.102-1.078v-1.383c0-.82-.282-1.054-1.102-1.054h-1.383c-.82 0-1.101.234-1.101 1.054v1.383c0 .82.28 1.078 1.101 1.078m7.781 0h1.383c.82 0 1.102-.258 1.102-1.078v-1.383c0-.82-.281-1.054-1.102-1.054h-1.383c-.82 0-1.078.234-1.078 1.054v1.383c0 .82.258 1.078 1.078 1.078m7.805 0h1.36c.843 0 1.101-.258 1.101-1.078v-1.383c0-.82-.258-1.054-1.102-1.054h-1.359c-.82 0-1.101.234-1.101 1.054v1.383c0 .82.28 1.078 1.101 1.078"
          fill="currentColor"
        ></path>
      </svg>
    </AccessibleIcon>
  );
}

export function ChevronUpIcon({
  "aria-label": arialLabel,
  ...props
}: JSX.IntrinsicElements["svg"]) {
  return (
    <AccessibleIcon aria-label={arialLabel}>
      <svg
        fill="none"
        height="24"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path d="m18 15-6-6-6 6" />
      </svg>
    </AccessibleIcon>
  );
}

export function ChevronDownIcon({
  "aria-label": arialLabel,
  ...props
}: JSX.IntrinsicElements["svg"]) {
  return (
    <AccessibleIcon aria-label={arialLabel}>
      <svg
        fill="currentColor"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          clipRule="evenodd"
          d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z"
          fillRule="evenodd"
        />
      </svg>
    </AccessibleIcon>
  );
}

export function ChevronRightIcon({
  "aria-label": arialLabel,
  ...props
}: JSX.IntrinsicElements["svg"]) {
  return (
    <AccessibleIcon aria-label={arialLabel}>
      <svg
        fill="none"
        height="24"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path d="m9 18 6-6-6-6" />
      </svg>
    </AccessibleIcon>
  );
}

export function ChevronLeftIcon({
  "aria-label": arialLabel,
  ...props
}: JSX.IntrinsicElements["svg"]) {
  return (
    <AccessibleIcon aria-label={arialLabel}>
      <svg
        fill="none"
        height="24"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path d="m15 18-6-6 6-6" />
      </svg>
    </AccessibleIcon>
  );
}

export function SearchIcon({
  "aria-label": arialLabel,
  ...props
}: JSX.IntrinsicElements["svg"]) {
  return (
    <AccessibleIcon aria-label={arialLabel}>
      <svg
        fill="currentColor"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          clipRule="evenodd"
          d="M9.965 11.026a5 5 0 1 1 1.06-1.06l2.755 2.754a.75.75 0 1 1-1.06 1.06l-2.755-2.754ZM10.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
          fillRule="evenodd"
        ></path>
      </svg>
    </AccessibleIcon>
  );
}

export function SpinnerIcon({
  "aria-label": arialLabel,
  className,
  ...props
}: JSX.IntrinsicElements["svg"]) {
  return (
    <AccessibleIcon aria-label={arialLabel}>
      <svg
        className={twMerge("animate-spin text-zinc-400/75", className)}
        fill="none"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          fill="currentColor"
        ></path>
      </svg>
    </AccessibleIcon>
  );
}

export function CopyIcon({
  "aria-label": arialLabel,
  ...props
}: JSX.IntrinsicElements["svg"]) {
  return (
    <AccessibleIcon aria-label={arialLabel}>
      <svg
        fill="none"
        height="24"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <rect height="14" rx="2" ry="2" width="14" x="8" y="8" />
        <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
      </svg>
    </AccessibleIcon>
  );
}

export function EmailIcon({
  "aria-label": arialLabel,
  ...props
}: JSX.IntrinsicElements["svg"]) {
  return (
    <AccessibleIcon aria-label={arialLabel}>
      <svg
        fill="none"
        height="16"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.66667"
        viewBox="0 0 19 16"
        width="19"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path d="M1.16675 3.83398L7.97085 8.59685C8.52182 8.98254 8.79731 9.17538 9.09697 9.25007C9.36166 9.31605 9.6385 9.31605 9.9032 9.25007C10.2029 9.17538 10.4783 8.98254 11.0293 8.59685L17.8334 3.83398M5.16675 14.6673H13.8334C15.2335 14.6673 15.9336 14.6673 16.4684 14.3948C16.9388 14.1552 17.3212 13.7727 17.5609 13.3023C17.8334 12.7675 17.8334 12.0674 17.8334 10.6673V5.33398C17.8334 3.93385 17.8334 3.23379 17.5609 2.69901C17.3212 2.2286 16.9388 1.84615 16.4684 1.60647C15.9336 1.33398 15.2335 1.33398 13.8334 1.33398H5.16675C3.76662 1.33398 3.06655 1.33398 2.53177 1.60647C2.06137 1.84615 1.67892 2.2286 1.43923 2.69901C1.16675 3.23379 1.16675 3.93385 1.16675 5.33398V10.6673C1.16675 12.0674 1.16675 12.7675 1.43923 13.3023C1.67892 13.7727 2.06137 14.1552 2.53177 14.3948C3.06655 14.6673 3.76662 14.6673 5.16675 14.6673Z" />
      </svg>
    </AccessibleIcon>
  );
}

export function LockIcon({
  "aria-label": arialLabel,
  ...props
}: JSX.IntrinsicElements["svg"]) {
  return (
    <AccessibleIcon aria-label={arialLabel}>
      <svg
        fill="none"
        height="28"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 28 28"
        width="28"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path d="M19.8332 11.6667V9.33333C19.8332 6.11167 17.2215 3.5 13.9998 3.5C10.7782 3.5 8.1665 6.11167 8.1665 9.33333V11.6667M13.9998 16.9167V19.25M10.2665 24.5H17.7332C19.6934 24.5 20.6734 24.5 21.4221 24.1185C22.0807 23.783 22.6161 23.2475 22.9517 22.589C23.3332 21.8403 23.3332 20.8602 23.3332 18.9V17.2667C23.3332 15.3065 23.3332 14.3264 22.9517 13.5777C22.6161 12.9191 22.0807 12.3837 21.4221 12.0481C20.6734 11.6667 19.6934 11.6667 17.7332 11.6667H10.2665C8.30632 11.6667 7.32623 11.6667 6.57754 12.0481C5.91897 12.3837 5.38354 12.9191 5.04798 13.5777C4.6665 14.3264 4.6665 15.3065 4.6665 17.2667V18.9C4.6665 20.8602 4.6665 21.8403 5.04798 22.589C5.38354 23.2475 5.91897 23.783 6.57754 24.1185C7.32623 24.5 8.30632 24.5 10.2665 24.5Z" />
      </svg>
    </AccessibleIcon>
  );
}

export function XIcon2({ ...props }: JSX.IntrinsicElements["svg"]) {
  return (
    <svg
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 4L4 12M4 4L12 12"
        stroke="#667085"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}
